export const palette = {
  primary: '#1D4ED8',
  secondary: '#0F172A',
  accent: '#0EA5E9',
  success: '#047857',
  warning: '#B45309',
  error: '#BE123C',
  info: '#6D28D9',
}

export const v1Theme = {
  primary: '#1976D2',
  secondary: '#424242',
  accent: '#82B1FF',
  error: '#FF5252',
  info: '#2196F3',
  success: '#4CAF50',
  warning: '#FB8C00',
}
